




































































import Vue from "vue";
import { ErrorEventFilterForm } from "../forms/ErrorEventFilterForm";
import { ErrorEvent } from "../models/ErrorEvent";
export default Vue.extend({
  data() {
    const errorInformation: ErrorEvent[] = [];
    const isLoading = true;
    return {
      errorInformation,
      isLoading
    };
  },
  async created() {
    await this.getErrorItemById();
    this.isLoading = false;
  },
  methods: {
    async getErrorItemById() {
      const id = this.$route.params.id;
      const {
        data
      } = await (this as any).$dep.errorEventUseCase.getErrorItemById(id);
      this.errorInformation.push(data);
    }
  }
});
